export function relativeTime(when: number | string | null | undefined, now = Date.now()): string {
  if (when === null || when === undefined) return 'never';
  const t = typeof when === 'number' ? when : Date.parse(when);
  if (Number.isNaN(t)) return 'never';
  const s = Math.round((now - t) / 1000);
  if (s < 10) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`;
  return new Date(t).toLocaleDateString();
}

export interface ConflictLike {
  kind: 'superseded' | 'rejected' | 'deleted_elsewhere' | 'deletion_overridden';
  field: 'content' | 'location' | 'deletion';
  reason?: string;
  title: string;
}

/** One-line, user-facing explanation of how a conflict was resolved. */
export function describeConflict(c: ConflictLike, byDevice?: string | null): string {
  const who = byDevice ? `on ${byDevice}` : 'on another device';
  const what = `“${c.title}”`;
  switch (c.kind) {
    case 'superseded':
      return c.field === 'content'
        ? `${what} was renamed ${who} more recently; that version was kept.`
        : `${what} was moved ${who} more recently; that location was kept.`;
    case 'deleted_elsewhere':
      return `${what} was deleted ${who} after your change.`;
    case 'deletion_overridden':
      return `${what} was kept because it was edited ${who} after you deleted it.`;
    case 'rejected':
      if (c.reason === 'cycle') return `Moving ${what} was undone: it would have put a folder inside itself.`;
      if (c.reason === 'invalid_parent') return `${what} was placed in Other bookmarks because its folder no longer exists.`;
      return `A change to ${what} was refused by the server (${c.reason ?? 'invalid'}).`;
  }
}
